module.exports = __webpack_public_path__ + "assets/feature-3.svg";